import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastrDownloadService {
  toastRef: any;
  toastrMsg = 'Téléchargement en cours';
  successMsg = 'Fichier téléchargé';
  customToastr = `<div class="d-flex flex-column justify-content-center">
  <div>Téléchargement en cours</div>
  <div class="d-flex justify-content-center">
    <div class="spinner-grow text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-grow text-secondary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-grow text-success" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-grow text-danger" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
`;

  msgDowloaded = `
    <div class="d-flex justify-content-center">
      <i class="fa fa-check my-toastr-icon"></i>
      <span>Fichier téléchargé</span>
    </div>
`;
  constructor(private readonly toastrService: ToastrService) {}

  showToast(toastrMsg?: any) {
    // si il y un msg personnalisé
    if (toastrMsg) {
      this.setCustumMsg(toastrMsg);
    }
    this.toastRef = this.toastrService.show(this.customToastr, '', {
      enableHtml: true,
      disableTimeOut: true,
      positionClass: 'toast-bottom-center',
      toastClass: 'toast download'
    });
    if (toastrMsg) {
      this.setBackToDefault();
    }
  }

  downloadSuccess(successMsg?: any) {
    this.toastrService.clear(this.toastRef.toastId);
    if (successMsg) {
      this.setMsgDowloaded(successMsg);

      this.toastRef = this.toastrService.show(this.msgDowloaded, '', {
        enableHtml: true,
        positionClass: 'toast-bottom-center',
        toastClass: 'toast download'
      });
    }

    if (successMsg) {
      this.successBackToDefault();
    }
  }

  removeToast() {
    this.toastrService.clear(this.toastRef.toastId);
  }

  setCustumMsg(toastrMsg?: any) {
    this.customToastr = `<div class="d-flex flex-column justify-content-center">
    <div>${toastrMsg}</div>
    <div class="d-flex justify-content-center">
      <div class="spinner-grow text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
  `;
  }

  setMsgDowloaded(successMsg?: any) {
    this.msgDowloaded = `
    <div class="d-flex justify-content-center">
      <i class="fa fa-check my-toastr-icon"></i>
      <span>${successMsg}</span>
    </div>`;
  }

  setBackToDefault() {
    this.customToastr = `<div class="d-flex flex-column justify-content-center">
    <div>Téléchargement en cours</div>
    <div class="d-flex justify-content-center">
      <div class="spinner-grow text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>`;
  }

  successBackToDefault() {
    this.msgDowloaded = `
    <div class="d-flex justify-content-center">
      <i class="fa fa-check my-toastr-icon"></i>
      <span>Fichier téléchargé</span>
    </div>`;
  }
}
